import _ from 'lodash';
import { PromiseState } from 'react-refetch';

import { ListState } from './list.reducer';

export const getItemsListOrdered = <T>(state: ListState<T>): T[] =>
  _.map(state.idsOrdered, (id) => state.itemsMap[id]);

export const getListPromiseStateOrdered = <T>(
  state: ListState<T>,
): PromiseState<T[]> => {
  if (state.loadState.fulfilled) {
    const list: T[] = _.map(state.idsOrdered, (id) => state.itemsMap[id]);
    return PromiseState.resolve(list);
  }

  if (state.loadState.pending) {
    return PromiseState.create<T[]>();
  }

  return PromiseState.reject<T[]>();
};
